module.exports = __webpack_public_path__ + "img/Best of Dreiseen weiss.bf7c17e1.jpg";